import { InstructionItem } from 'store/ducks/Global/types';

export const getInstructionsModel = (t: any): InstructionItem[] => [
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.FOLLOW_ORDER'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.FOLLOW_ORDER_VALUE'),
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.MANDATORY_FIELDS'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.MANDATORY_FIELDS_VALUE'),
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.REGULATORY_INSTRUCTIONS'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.REGULATORY_INSTRUCTIONS_VALUE'),
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.FILTERS'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.FILTERS_VALUE'),
  },
  {
    type: 'group',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.ADDITIONAL_FIELDS.TITLE'),
    items: [
      t('WORKING_AREAS.INSTRUCTIONS_HELP.ADDITIONAL_FIELDS.ITEM_1'),
      t('WORKING_AREAS.INSTRUCTIONS_HELP.ADDITIONAL_FIELDS.ITEM_2'),
    ],
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.CORRECTIONS'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.CORRECTIONS_VALUE'),
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.NO_AUTOSAVE'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.NO_AUTOSAVE_VALUE'),
  },
  {
    type: 'text',
    label: t('WORKING_AREAS.INSTRUCTIONS_HELP.DELETING_ROWS'),
    value: t('WORKING_AREAS.INSTRUCTIONS_HELP.DELETING_ROWS_VALUE'),
  },
];
